import React from "react"
import { Link } from "gatsby"

export const pageKeys = {
  HOME: "home",
  ABOUT_ME: "aboutMe",
  WHAT_I_OFFER: "whatIOffer",
  BOOK_A_SESSION: "bookASession",
  FAQ: "faq",
  BLOG: "blog"
}

const linkData = {
  [pageKeys.HOME]: { pageTitle: "Home", to: "/" },
  [pageKeys.ABOUT_ME]: { pageTitle: "About Me", to: "/about-me/" },
  [pageKeys.WHAT_I_OFFER]: { pageTitle: "What I Offer", to: "/what-i-offer/" },
  [pageKeys.BOOK_A_SESSION]: {
    pageTitle: "Book A Session",
    to: "/book-a-session/"
  },
  [pageKeys.FAQ]: { pageTitle: "FAQ", to: "/faq/" },
  [pageKeys.BLOG]: { pageTitle: "Blog", to: "/blog/" }
}

export const headerNavLinks = Object.values(linkData).map(link => ({
  text: link.pageTitle,
  to: link.to
}))

export const getLinkByPageKey = (
  pageKey,
  hasPageSuffixInLink,
  linkTitle,
  state
) => {
  const pageLinkData = linkData[pageKey]

  const title = linkTitle || pageLinkData.pageTitle

  return (
    <Link to={`${pageLinkData.to}`} state={state}>
      {hasPageSuffixInLink ? `${title} page` : title}
    </Link>
  )
}
